(function ($) {
    'use strict';
    var tabsProduct = function () {
      // Show the first tab and hide the rest
      $('#tabs-nav li:first-child').addClass('active');
      $('.tab-content').hide();
      $('.tab-content:first').show();

      // Click function
      $('#tabs-nav li').click(function(){
        $('#tabs-nav li').removeClass('active');
        $(this).addClass('active');
        $('.tab-content').hide();

        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
      });    
    };
  
    var tabsConsignmentsPage = function () {
      // Show the first tab and hide the rest
      $('.main_Page--Consignments #tabs-nav li:first-child').addClass('active');
      $('.main_Page--Consignments tab-content').hide();
      $('.main_Page--Consignments .tab-content:first').show();

      // Click function
      $('.main_Page--Consignments #tabs-nav li').click(function(){
        $('.main_Page--Consignments #tabs-nav li').removeClass('active');
        $(this).addClass('active');
        $('.main_Page--Consignments .tab-content').hide();

        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
      });    
    };

    var windowsize = $(window).width();
    var sliderLogoList = function () {
      if (windowsize <= 768) {
        $('.main_LogoList').flickity({
          cellAlign: 'left',
          contain: false,
          pageDots: false,
          prevNextButtons: false,
          wrapAround: true
        });
      }
    };      
    jQuery(window).resize(function() {
      var windowsize = $(window).width();
    });
    jQuery(document).ready(function ($) {
      tabsProduct();
      sliderLogoList();
    });

})(jQuery);

